import type { FaireProductEntity } from "../../entity_types/product";

export const p_356mgwtqp2: FaireProductEntity = {
  token: "p_356mgwtqp2",
  type: "product",
  name: "Nutmeg Crew Socks",
  brandToken: "b_46c570c5",
  brandName: "Solmate Socks",
  imageUrl:
    "https://cdn.faire.com/fastly/dda917705aa939ccc825930b9556895607bd2d546d6765b1a1cdb0e7f35b6f29.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b65b6c3f3df4f6f5121492639c90dfd381cac9f7d68f75f1dcac945ec07b9d15.jpeg",
    "https://cdn.faire.com/fastly/82f8383cf48d5bfe65043380f986901289cd3653626b65c0c8ce44235a7feeb9.jpeg",
  ],
  priceDollars: 9.25,
  description:
    "Like the quintessential autumn spice, these Nutmeg Crew Socks are every bit of warm and comfort... with a little bit of a kick.\n\nColors in this sock: navy, pale yellow, gray-blue, burnt orange.",
  tags: [],
  msrpDollars: 19.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:25.400Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
